import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <Container>
      <Row>
        <Col>
          <Link to="/impressum" style={{ textDecoration: "none" }}>
            <span style={{ color: "#757070" }}>Impressum</span>
          </Link>
        </Col>
      </Row>
    </Container>
  );
}
